module.exports = __webpack_public_path__ + "img/VN.3c682ac6.png";